// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Button } from '@/components/ui/button';
// import { Card } from '@/components/ui/card';
// import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
// import { Input } from '@/components/ui/input';
// import { Label } from '@/components/ui/label';
// import { toast } from 'sonner';
// import { Plus, Users, Edit, Trash2, Eye } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// const Customers = () => {
//   const [customers, setCustomers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [editingCustomer, setEditingCustomer] = useState(null);
//   const [formData, setFormData] = useState({
//     name: '',
//     company: '',
//     email: '',
//     phone: '',
//     address: '',
//     currency: 'USD',
//   });
//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchCustomers();
//   }, []);

//   const fetchCustomers = async () => {
//     try {
//       const token = localStorage.getItem('token');
//       const response = await axios.get(`${API}/customers`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setCustomers(response.data);
//     } catch (error) {
//       toast.error('Failed to fetch customers');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const token = localStorage.getItem('token');

//     try {
//       if (editingCustomer) {
//         await axios.put(`${API}/customers/${editingCustomer.id}`, formData, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         toast.success('Customer updated successfully');
//       } else {
//         await axios.post(`${API}/customers`, formData, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         toast.success('Customer created successfully');
//       }

//       setDialogOpen(false);
//       resetForm();
//       fetchCustomers();
//     } catch (error) {
//       toast.error('Failed to save customer');
//     }
//   };

//   const handleEdit = (customer) => {
//     setEditingCustomer(customer);
//     setFormData({
//       name: customer.name,
//       company: customer.company || '',
//       email: customer.email || '',
//       phone: customer.phone || '',
//       address: customer.address || '',
//       currency: customer.currency,
//     });
//     setDialogOpen(true);
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this customer?')) return;

//     try {
//       const token = localStorage.getItem('token');
//       await axios.delete(`${API}/customers/${id}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       toast.success('Customer deleted successfully');
//       fetchCustomers();
//     } catch (error) {
//       toast.error('Failed to delete customer');
//     }
//   };

//   const resetForm = () => {
//     setEditingCustomer(null);
//     setFormData({
//       name: '',
//       company: '',
//       email: '',
//       phone: '',
//       address: '',
//       currency: 'USD',
//     });
//   };

//   return (
//     <div className="p-8 md:p-12" data-testid="customers-page">
//       <div className="flex items-center justify-between mb-12">
//         <h1 className="text-4xl md:text-5xl font-bold tracking-tight">Customers</h1>
//         <Dialog open={dialogOpen} onOpenChange={(open) => { setDialogOpen(open); if (!open) resetForm(); }}>
//           <DialogTrigger asChild>
//             <Button className="gap-2" data-testid="create-customer-button">
//               <Plus className="w-4 h-4" />
//               Add Customer
//             </Button>
//           </DialogTrigger>
//           <DialogContent className="max-w-2xl">
//             <DialogHeader>
//               <DialogTitle>{editingCustomer ? 'Edit Customer' : 'Create New Customer'}</DialogTitle>
//             </DialogHeader>
//             <form onSubmit={handleSubmit} className="space-y-6 mt-4">
//               <div className="grid grid-cols-2 gap-4">
//                 <div className="col-span-2">
//                   <Label>Customer Name *</Label>
//                   <Input
//                     value={formData.name}
//                     onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//                     required
//                     placeholder="John Doe"
//                     data-testid="customer-name-input"
//                   />
//                 </div>
//                 <div className="col-span-2">
//                   <Label>Company</Label>
//                   <Input
//                     value={formData.company}
//                     onChange={(e) => setFormData({ ...formData, company: e.target.value })}
//                     placeholder="Acme Inc."
//                   />
//                 </div>
//                 <div>
//                   <Label>Email</Label>
//                   <Input
//                     type="email"
//                     value={formData.email}
//                     onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//                     placeholder="john@example.com"
//                   />
//                 </div>
//                 <div>
//                   <Label>Phone</Label>
//                   <Input
//                     value={formData.phone}
//                     onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
//                     placeholder="+1 (555) 000-0000"
//                   />
//                 </div>
//                 <div className="col-span-2">
//                   <Label>Address</Label>
//                   <Input
//                     value={formData.address}
//                     onChange={(e) => setFormData({ ...formData, address: e.target.value })}
//                     placeholder="123 Main St, City, Country"
//                   />
//                 </div>
//                 <div>
//                   <Label>Preferred Currency *</Label>
//                   <select
//                     className="w-full px-3 py-2 border border-input rounded-md bg-white"
//                     value={formData.currency}
//                     onChange={(e) => setFormData({ ...formData, currency: e.target.value })}
//                     required
//                   >
//                     <option value="USD">USD - US Dollar</option>
//                     <option value="EUR">EUR - Euro</option>
//                     <option value="GBP">GBP - British Pound</option>
//                     <option value="INR">INR - Indian Rupee</option>
//                     <option value="CAD">CAD - Canadian Dollar</option>
//                     <option value="AUD">AUD - Australian Dollar</option>
//                   </select>
//                 </div>
//               </div>
//               <div className="flex gap-3 justify-end">
//                 <Button type="button" variant="outline" onClick={() => { setDialogOpen(false); resetForm(); }}>
//                   Cancel
//                 </Button>
//                 <Button type="submit" data-testid="save-customer-button">
//                   {editingCustomer ? 'Update' : 'Create'}
//                 </Button>
//               </div>
//             </form>
//           </DialogContent>
//         </Dialog>
//       </div>

//       {loading ? (
//         <div className="text-muted-foreground">Loading...</div>
//       ) : customers.length === 0 ? (
//         <Card className="p-12 text-center border-dashed">
//           <Users className="w-16 h-16 text-muted-foreground mx-auto mb-4" />
//           <p className="text-lg text-muted-foreground">No customers yet. Create your first customer!</p>
//         </Card>
//       ) : (
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {customers.map((customer) => (
//             <Card key={customer.id} className="p-8 hover:shadow-hover transition-all border-border/50" data-testid={`customer-card-${customer.id}`}>
//               <div className="flex items-start justify-between mb-4">
//                 <div>
//                   <h3 className="font-bold text-lg">{customer.name}</h3>
//                   {customer.company && <p className="text-sm text-muted-foreground">{customer.company}</p>}
//                 </div>
//                 <div className="bg-primary/10 px-3 py-1 rounded-full">
//                   <span className="text-xs font-semibold text-primary">{customer.currency}</span>
//                 </div>
//               </div>
//               <div className="space-y-2 text-sm text-muted-foreground mb-6">
//                 {customer.email && <p>{customer.email}</p>}
//                 {customer.phone && <p>{customer.phone}</p>}
//                 {customer.address && <p className="text-xs">{customer.address}</p>}
//               </div>
//               <div className="flex gap-2">
//                 <Button
//                   variant="outline"
//                   size="sm"
//                   onClick={() => navigate(`/customers/${customer.id}`)}
//                   className="flex-1"
//                   data-testid={`view-customer-${customer.id}`}
//                 >
//                   <Eye className="w-4 h-4 mr-2" />
//                   View
//                 </Button>
//                 <Button
//                   variant="outline"
//                   size="sm"
//                   onClick={() => handleEdit(customer)}
//                   data-testid={`edit-customer-${customer.id}`}
//                 >
//                   <Edit className="w-4 h-4" />
//                 </Button>
//                 <Button
//                   variant="destructive"
//                   size="sm"
//                   onClick={() => handleDelete(customer.id)}
//                   data-testid={`delete-customer-${customer.id}`}
//                 >
//                   <Trash2 className="w-4 h-4" />
//                 </Button>
//               </div>
//             </Card>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Customers;
import React, { useState, useEffect } from 'react';
// import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { Plus, Users, Edit, Trash2, Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

// ⬇️ NEW: Firebase imports
import { db, auth } from '../firebase';
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  query,
  where,
  serverTimestamp,
} from 'firebase/firestore';

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    address: '',
    currency: 'USD',
    gst_number: '',
    state: '',
  });
  const navigate = useNavigate();

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    setLoading(true);
    try {
      const user = auth.currentUser;
      if (!user) {
        setCustomers([]);
        setLoading(false);
        return;
      }

      // Old axios version:
      // const token = localStorage.getItem('token');
      // const response = await axios.get(`${API}/customers`, {
      //   headers: { Authorization: `Bearer ${token}` },
      // });
      // setCustomers(response.data);

      const q = query(
        collection(db, 'customers'),
        // where('userId', '==', user.uid)
      );
      const snap = await getDocs(q);
      const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setCustomers(list);
    } catch (error) {
      console.error(error);
      toast.error('Failed to fetch customers');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // const token = localStorage.getItem('token');

    try {
      const user = auth.currentUser;
      if (!user) {
        toast.error('Not logged in');
        return;
      }

      if (editingCustomer) {
        // await axios.put(`${API}/customers/${editingCustomer.id}`, formData, {
        //   headers: { Authorization: `Bearer ${token}` },
        // });

        const ref = doc(db, 'customers', editingCustomer.id);
        await updateDoc(ref, {
          ...formData,
          updatedAt: serverTimestamp(),
        });

        toast.success('Customer updated successfully');
      } else {
        // await axios.post(`${API}/customers`, formData, {
        //   headers: { Authorization: `Bearer ${token}` },
        // });

        await addDoc(collection(db, 'customers'), {
          ...formData,
          userId: user.uid,
          createdAt: serverTimestamp(),
        });

        toast.success('Customer created successfully');
      }

      setDialogOpen(false);
      resetForm();
      fetchCustomers();
    } catch (error) {
      console.error(error);
      toast.error('Failed to save customer');
    }
  };

  const handleEdit = (customer) => {
    setEditingCustomer(customer);
    setFormData({
      name: customer.name,
      company: customer.company || '',
      email: customer.email || '',
      phone: customer.phone || '',
      address: customer.address || '',
      currency: customer.currency,
      gst_number: customer.gst_number || '',
      state: customer.state || '',
    });
    setDialogOpen(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this customer?')) return;

    try {
      // const token = localStorage.getItem('token');
      // await axios.delete(`${API}/customers/${id}`, {
      //   headers: { Authorization: `Bearer ${token}` },
      // });

      await deleteDoc(doc(db, 'customers', id));

      toast.success('Customer deleted successfully');
      fetchCustomers();
    } catch (error) {
      console.error(error);
      toast.error('Failed to delete customer');
    }
  };

  const resetForm = () => {
    setEditingCustomer(null);
    setFormData({
      name: '',
      company: '',
      email: '',
      phone: '',
      address: '',
      currency: 'USD',
      gst_number: '',
      state: '',
    });
  };

  return (
    <div className="p-8 md:p-12" data-testid="customers-page">
      <div className="flex items-center justify-between mb-12">
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight">Customers</h1>
        <Dialog
          open={dialogOpen}
          onOpenChange={(open) => {
            setDialogOpen(open);
            if (!open) resetForm();
          }}
        >
          <DialogTrigger asChild>
            <Button className="gap-2" data-testid="create-customer-button">
              <Plus className="w-4 h-4" />
              Add Customer
            </Button>
          </DialogTrigger>
          <DialogContent className="max-w-2xl">
            <DialogHeader>
              <DialogTitle>
                {editingCustomer ? 'Edit Customer' : 'Create New Customer'}
              </DialogTitle>
            </DialogHeader>
            <form onSubmit={handleSubmit} className="space-y-6 mt-4">
              <div className="grid grid-cols-2 gap-4">
                <div className="col-span-2">
                  <Label>Customer Name *</Label>
                  <Input
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                    placeholder="John Doe"
                    data-testid="customer-name-input"
                  />
                </div>
                <div className="col-span-2">
                  <Label>Company</Label>
                  <Input
                    value={formData.company}
                    onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                    placeholder="Acme Inc."
                  />
                </div>
                <div>
                  <Label>Email</Label>
                  <Input
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    placeholder="john@example.com"
                  />
                </div>
                <div>
                  <Label>Phone</Label>
                  <Input
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    placeholder="+1 (555) 000-0000"
                  />
                </div>
                <div className="col-span-2">
                  <Label>Address</Label>
                  <Input
                    value={formData.address}
                    onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                    placeholder="123 Main St, City, Country"
                  />
                </div>
                <div>
                  <Label>GST Number</Label>
                  <Input
                    value={formData.gst_number}
                    onChange={(e) => setFormData({ ...formData, gst_number: e.target.value })}
                    placeholder="GSTIN"
                  />
                </div>
                <div>
                  <Label>State</Label>
                  <Input
                    value={formData.state}
                    onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                    placeholder="e.g. 24-Gujarat"
                  />
                </div>
                <div>
                  <Label>Preferred Currency *</Label>
                  <select
                    className="w-full px-3 py-2 border border-input rounded-md bg-white"
                    value={formData.currency}
                    onChange={(e) =>
                      setFormData({ ...formData, currency: e.target.value })
                    }
                    required
                  >
                    <option value="USD">USD - US Dollar</option>
                    <option value="EUR">EUR - Euro</option>
                    <option value="GBP">GBP - British Pound</option>
                    <option value="INR">INR - Indian Rupee</option>
                    <option value="CAD">CAD - Canadian Dollar</option>
                    <option value="AUD">AUD - Australian Dollar</option>
                  </select>
                </div>
              </div>
              <div className="flex gap-3 justify-end">
                <Button
                  type="button"
                  variant="outline"
                  onClick={() => {
                    setDialogOpen(false);
                    resetForm();
                  }}
                >
                  Cancel
                </Button>
                <Button type="submit" data-testid="save-customer-button">
                  {editingCustomer ? 'Update' : 'Create'}
                </Button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
      </div>

      {loading ? (
        <div className="text-muted-foreground">Loading...</div>
      ) : customers.length === 0 ? (
        <Card className="p-12 text-center border-dashed">
          <Users className="w-16 h-16 text-muted-foreground mx-auto mb-4" />
          <p className="text-lg text-muted-foreground">
            No customers yet. Create your first customer!
          </p>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {customers.map((customer) => (
            <Card
              key={customer.id}
              className="p-8 hover:shadow-hover transition-all border-border/50"
              data-testid={`customer-card-${customer.id}`}
            >
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="font-bold text-lg">{customer.name}</h3>
                  {customer.company && (
                    <p className="text-sm text-muted-foreground">
                      {customer.company}
                    </p>
                  )}
                </div>
                <div className="bg-primary/10 px-3 py-1 rounded-full">
                  <span className="text-xs font-semibold text-primary">
                    {customer.currency}
                  </span>
                </div>
              </div>
              <div className="space-y-2 text-sm text-muted-foreground mb-6">
                {customer.email && <p>{customer.email}</p>}
                {customer.phone && <p>{customer.phone}</p>}
                {customer.address && (
                  <p className="text-xs">{customer.address}</p>
                )}
              </div>
              <div className="flex gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => navigate(`/customers/${customer.id}`)}
                  className="flex-1"
                  data-testid={`view-customer-${customer.id}`}
                >
                  <Eye className="w-4 h-4 mr-2" />
                  View
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => handleEdit(customer)}
                  data-testid={`edit-customer-${customer.id}`}
                >
                  <Edit className="w-4 h-4" />
                </Button>
                <Button
                  variant="destructive"
                  size="sm"
                  onClick={() => handleDelete(customer.id)}
                  data-testid={`delete-customer-${customer.id}`}
                >
                  <Trash2 className="w-4 h-4" />
                </Button>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default Customers;
